import API from "..";

export const getDomains = async () => {
  const response = await API.get(`/domain/list?page=1&limit=15`);

  return response.data.data;
};

export const createDomain = async (data: { domainName: string }) => {
  const response = await API.post(`/domain/add`, data);

  return response.data;
};

export const initiateVerifyDomain = async (data: {
  email: string;
  domainUid: string;
}) => {
  const response = await API.post(`/domain/send-otp`, data);

  return response.data;
};

export const verifyDomain = async (data: {
  code: string | number;
  domainUid: string;
}) => {
  const response = await API.post(`/domain/verify-otp`, data);

  return response.data;
};
export const deleteDomain = async (data: {
  domainUid: string;
}) => {
  const response = await API.delete(`/domain/delete`,{data:data});

  return response.data;
};
